export enum breakpoints {
  mobile = "425px",
  tablet = "768px",
  laptop = "1440px",
  desktop = "1699px",
  ultrawide = "2560px",
}
